// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3J8DH","errorLogs":"styles_errorLogs__27mtK"};